import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Api from "../services/globalBibleApi";
import Table from "../components/Table";
import BreadCrumbs from "../components/BreadCrumbs";
import { AudioIcon, TextIcon } from "../components/Icons";
import Badge from "../components/Badge";

const Bibles = () => {
  const [bibles, setBibles] = useState();
  const [refreshTime, setRefreshTime] = useState(new Date().getTime());

  useEffect(() => {
    Api.listBibles().then((bibleList = []) => {
      setBibles(bibleList);
    });
  }, [refreshTime]);

  const handleRefresh = () => {
    Api.refreshBibles()
      .then(() => setRefreshTime(new Date().getTime()))
      .catch(console.error); // eslint-disable-line
  };

  return (
    <div>
      <BreadCrumbs
        title="Bibles List"
        paths={[{ title: "Bibles", link: "/sites" }]}
        actions={
          <span className="inline-flex rounded-md shadow-sm">
            <button
              type="button"
              onClick={handleRefresh}
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm hover:no-underline leading-5 font-medium rounded-md text-white bg-blue-600 hover:bg-blue-500 focus:outline-none focus:border-blue-700 focus:shadow-outline-blue active:bg-blue-700 transition ease-in-out duration-150"
            >
              Refresh Cache
            </button>
          </span>
        }
      />
      <Table
        className="w-full"
        headers={["Name", "ID", "Status", "Actions"]}
        loading={!bibles && !Array.isArray(bibles)}
        rows={(bibles || []).map(bible => {
          return {
            key: bible.id,
            row: [
              <Link
                to={`/bibles/${bible.id}`}
                title={bible.name}
                className="font-bold"
              >
                <span className="text-gray-500 inline-block mr-2 -mb-1">
                  {bible.type === "text" ? (
                    <TextIcon className="w-5 h-5" />
                  ) : (
                    <AudioIcon className="w-5 h-5" />
                  )}
                </span>
                {bible.name.slice(0, 30)}
                {bible.name.length > 30 && "..."}
              </Link>,
              <span className="text-sm bg-blue-100 text-blue-700 rounded px-2 py-1 font-mono">
                {bible.id}
              </span>,
              <Badge type={bible.meta ? "primary" : ""}>
                {bible.meta ? "Modified" : "Unmodified"}
              </Badge>,
              <span className="inline-flex rounded-md shadow-sm">
                <Link
                  to={`/bibles/${bible.id}`}
                  className="inline-flex items-center px-2.5 py-1.5 border border-transparent text-xs leading-4 font-medium rounded text-white bg-blue-600 hover:bg-blue-500 focus:outline-none focus:border-blue-700 focus:shadow-outline-blue active:bg-blue-700 transition ease-in-out duration-150"
                >
                  Edit
                </Link>
              </span>
            ]
          };
        })}
      />
    </div>
  );
};

export default Bibles;
